import { render, staticRenderFns } from "./ReviewedValueControl.vue?vue&type=template&id=6ccc1d46&scoped=true&"
import script from "./ReviewedValueControl.vue?vue&type=script&lang=js&"
export * from "./ReviewedValueControl.vue?vue&type=script&lang=js&"
import style0 from "./ReviewedValueControl.vue?vue&type=style&index=0&id=6ccc1d46&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc1d46",
  null
  
)

export default component.exports